import React from "react";
import Modal from "../Modal/Modal";
import styles from "./ChangelogModal.module.css";

const ChangelogModal = ({ isOpen, onClose, changelog, loading }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Historia Aktualizacji">
      <div className={styles.changelogContent}>
        {loading ? (
          <p>Ładowanie...</p>
        ) : (
          changelog.map((entry, index) => (
            <div key={index} className={styles.entry}>
              <h3 className={styles.title}>
                {entry.title}{" "}
                <span className={styles.version}>(v{entry.version})</span>
              </h3>
              <p className={styles.description}>{entry.description}</p>
            </div>
          ))
        )}
      </div>
    </Modal>
  );
};

export default ChangelogModal;
